import { Col, Divider, Row, Select } from 'antd'
import * as React from 'react'
import { DATA_TYPE } from '../constants'

const { Option } = Select

interface Props {
  properties: {
    barType: { value: string }
  }
  onChange: (category: string, property: string, value: any) => void
}

const ComplicationPreview: React.FC<Props> = (props) => {
  const {
    properties: {
      barType: { value: barType }
    },
    onChange
  } = props
  return (
    <div className="meta-form meta-complicationPreview">
      <Row gutter={[0, 24]} justify="space-around" align="middle">
        <Col span={6}>数据来源</Col>
        <Col span={18}>
          <Select
            defaultValue={barType}
            style={{ width: 120 }}
            onChange={(value) => {
              onChange('complicationPreview', 'defaultProvider', value)
            }}
          >
            {DATA_TYPE.map((item: any) => {
              return (
                <Option key={item.key} value={item.value}>
                  {item.key}
                </Option>
              )
            })}
          </Select>
        </Col>
      </Row>
      <Divider style={{ margin: '24px 0 0' }} />
    </div>
  )
}

export default ComplicationPreview
